/**
 * REWARD BAR LOGIC - V6.2 (FIXED)
 * This version fixes a bug where automatic discounts would incorrectly affect the progress bar calculation.
 * It now uses `original_total_price` instead of `total_price`.
 * NOTE: This script ONLY updates the visual bar. You MUST set up the actual discounts
 * (e.g., free shipping, automatic discounts) in your Shopify Admin panel.
 */

// This protective block ensures the script only runs once.
if (!window.rewardBarInitialized) {
  window.rewardBarInitialized = true;

  /**
   * Debounce function to limit the rate at which a function gets called.
   */
  function debounce(func, delay = 300) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  /**
   * Main function to update the visual rewards bar.
   */
  function updateRewardsBar(cart) {
    // --- SETUP YOUR REWARD TIERS HERE ---
    const tiers = [
      { amount: 250, label: "Free Shipping" },
      { amount: 500, label: "₹100 OFF" },
      { amount: 1000, label: "₹300 OFF" },
    ];

    const wrapper = document.querySelector('.rewards-bar-wrapper');
    if (!wrapper) return;

    const msgEl = wrapper.querySelector('.rewards-bar-message');
    const checkpoints = wrapper.querySelectorAll('.checkpoint');
    const connectors = wrapper.querySelectorAll('.connector');

    // --- *** THE FIX IS ON THIS LINE *** ---
    // Use the cart total BEFORE discounts are applied.
    const cartTotal = cart.original_total_price / 100;
    // --- *** END OF FIX *** ---

    const maxAmount = tiers[tiers.length - 1].amount;

    // Reset all states
    checkpoints.forEach(cp => cp.classList.remove('active', 'completed'));
    connectors.forEach(c => {
      c.classList.remove('unlocked', 'active');
      c.style.setProperty('--progress-percent', '0%');
    });
    wrapper.classList.remove('all-unlocked');

    let nextTier = null;
    let lastCompletedTierAmount = 0;
    let allUnlocked = true;

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const checkpoint = checkpoints[i];
      const connector = i > 0 ? connectors[i - 1] : null;

      if (cartTotal >= tier.amount) {
        // This tier is completed
        checkpoint.classList.add('completed');
        if (connector) connector.classList.add('unlocked');
        lastCompletedTierAmount = tier.amount;
      } else {
        // This tier is not yet completed
        allUnlocked = false;
        if (!nextTier) {
          // This is the next goal
          nextTier = tier;
          checkpoint.classList.add('active');
          if (connector) {
            connector.classList.add('active');
            const segmentTotal = tier.amount - lastCompletedTierAmount;
            const progressInSegment = cartTotal - lastCompletedTierAmount;
            const segmentPercent = Math.min((progressInSegment / segmentTotal) * 100, 100);
            connector.style.setProperty('--progress-percent', `${segmentPercent}%`);
          }
        }
      }
    }

    // Update the message based on the calculated state
    if (allUnlocked) {
      msgEl.innerHTML = `🎉 All rewards unlocked!`;
      wrapper.classList.add('all-unlocked');
    } else if (nextTier) {
      const amountNeeded = (nextTier.amount - cartTotal).toFixed(0);
      msgEl.innerHTML = `Just <span class="rewards-highlight">₹${amountNeeded}</span> away from <span class="rewards-highlight">${nextTier.label}</span>!`;
    }
    
    // Set a default message for an empty cart
    if (cartTotal === 0) {
      msgEl.textContent = `Add items to your cart to unlock rewards!`;
    }

    // Update ARIA attribute for accessibility
    const overallPercent = Math.min((cartTotal / maxAmount) * 100, 100);
    wrapper.setAttribute('aria-valuenow', Math.round(overallPercent));
  }

  /**
   * Function that fetches cart data and triggers the UI update.
   */
  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(updateRewardsBar)
      .catch(error => console.error('Error fetching cart for rewards bar:', error));
  }

  // Create a debounced version of our update function
  const debouncedFetchAndUpdate = debounce(fetchAndUpdate, 350);

  /**
   * OBSERVER & INITIALIZATION LOGIC
   */
  function observeCartDrawer() {
    const targetNode = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer') || document.body;
    
    if (!targetNode) {
        console.warn('Rewards Bar: Could not find a cart drawer to observe. Bar will only update on page load.');
        return;
    }

    const observer = new MutationObserver(() => {
        // Call the debounced function on any mutation.
        // It will only run after 350ms of no new mutations.
        debouncedFetchAndUpdate();
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }

  // Run the script once the page is loaded
  document.addEventListener('DOMContentLoaded', () => {
    fetchAndUpdate(); // Initial update
    observeCartDrawer(); // Start observing for changes
  });
  
}